import { type ICategoriesApi } from './ICategoriesApi';
import { ApiRoutes } from '../routes';
import { BaseApi } from '../base/BaseApi';
import { CategoryRequestDTO, CategoryResponseDTO } from 'infrastructure/dtos/category';

export class CategoriesApi extends BaseApi implements ICategoriesApi {
  public async getCategories(): Promise<{ data: CategoryResponseDTO[] }> {
    return await this.callApi(ApiRoutes.Categories.List);
  }

  public async createCategory(dto: CategoryRequestDTO): Promise<{ data: CategoryResponseDTO }> {
    return await this.callApi(ApiRoutes.Categories.Create, dto);
  }
}
